var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 48,
    viewBox: "0 0 62 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80004 13.9824C9.57604 13.9824 11.128 14.4048 12.456 15.2496C13.784 16.0944 14.808 17.2848 15.528 18.8208C16.264 20.3376 16.632 22.0944 16.632 24.0912C16.632 26.0688 16.264 27.8256 15.528 29.3616C14.808 30.8976 13.776 32.088 12.432 32.9328C11.104 33.7776 9.56004 34.2 7.80004 34.2H1.48804V13.9824H7.80004ZM7.53604 29.9376C9.08804 29.9376 10.296 29.4288 11.16 28.4112C12.024 27.3936 12.456 25.9536 12.456 24.0912C12.456 22.2288 12.024 20.7792 11.16 19.7424C10.296 18.7056 9.08804 18.1872 7.53604 18.1872H5.59204V29.9376H7.53604ZM25.4295 17.928V22.0176H30.9255V25.8192H25.4295V30.2544H31.6455V34.2H21.3255V13.9824H31.6455V17.928H25.4295ZM55.7899 13.9824V34.2H51.6859V22.0752L47.9179 34.2H44.6059L40.8139 22.0464V34.2H36.7099V13.9824H41.5579L46.2859 27.9792L50.9659 13.9824H55.7899Z",
    fill: "#183883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 12C49.0114 12 51.25 9.31371 51.25 6C51.25 2.68629 49.0114 0 46.25 0C43.4886 0 41.25 2.68629 41.25 6C41.25 9.31371 43.4886 12 46.25 12Z",
    fill: "#F12A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnboard);
export default __webpack_public_path__ + "static/media/logoOnboard.7489b9749ddf90951b76b8d87f95d8b1.svg";
export { ForwardRef as ReactComponent };